import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigCameras } from "../../../models/configcamera.model";
import { Observable } from 'rxjs';
import { AppFilter } from "app/models/app-filter.model";
import { AbConfigCameras } from 'app/abstract/full-pages/config-cameras/config-cameras.abstract';
import {toBinaryStr} from "app/commons/toBinaryStr";


@Injectable({ providedIn: 'root' })
export class ConfigCamerasService extends AbConfigCameras {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllConfigCameras(filter: AppFilter): Observable<any> {
    return this.get(`configcameras/filter_configcameras/${filter.encode()}`);
  }

  public allconfigcameras(): Observable<any> {
    return this.get(`configcameras/allconfigcameras/`);
  }

  public saveConfigCameras(configCamera: ConfigCameras): Observable<any> {
    return this.save("configcameras/", configCamera);
  }

  public saveAllConfigCameras(configCameras: ConfigCameras[]): Observable<any> {
    return this.save("configcameras/savelist/", configCameras);
  }

  deletar(id: number) {
    return this.delete("configcameras/", id);
  }

  public retornarCameras(configCamera: ConfigCameras): Observable<any> {
    return this.get("configcameras/", configCamera);
  }

  public listarCameras(config: ConfigCameras): Observable<any> {
    const headers = new HttpHeaders()
      .set("Authorization", 'Basic ' + btoa(toBinaryStr(`${config.login}:${config.senha}`)));

    return this.http.get(`${config.servidor}:${config.porta}/camerasnomes.cgi`, { headers, responseType: "text" });
  }

  public getDataCamerasDigifort(config: ConfigCameras): Observable<any> {
    return this.post("configcameras/allcamerasdigifort", config);
  }

  public listarCamerasDGuardNovaApi(config: ConfigCameras): Observable<any> {
    return this.post("configcameras/allcamerasdguard", config);
  }

  public testarECarregarCameras(configCamera: ConfigCameras): Observable<any> {
    return this.save("configcameras/testarecarregarcameras", configCamera);
  }

  public Base64Encode(str, encoding = 'utf-8') {
    const base64 = btoa(toBinaryStr(str));
    return base64;
  }

  public listarContasSigmaIM(config: ConfigCameras): Observable<any> {
    const headers = this.getHeaderSigmaIM(config)
    return this.http.get(`${config.servidor}partner/clients`, { headers, responseType: "json" });
  }

  public listarConfigCamerasSigmaIM(config: ConfigCameras, idConta: number): Observable<any> {
    const headers = this.getHeaderSigmaIM(config)
    return this.http.get(`${config.servidor}partner/clients/${idConta}/channels`, { headers, responseType: "json" });
  }

  private getHeaderSigmaIM(config: ConfigCameras) {
    const headers = new HttpHeaders()
    .set("Authorization", 'Bearer ' + config.senha);
    return headers
  }

  public getUrlStreamDigiFortSigma(configCamera: any, dataStrStream: string): string {
    const servidor = configCamera.configCamerasDTO.servidor;
    const porta = configCamera.configCamerasDTO.porta;
    const codigo = configCamera.codigo;

    const width = "640";
    const height = "480";
    const [data, hora] = dataStrStream.split(" ");
    const [dia, mes, ano] = data.split("/");
    const startDate = [ano, mes, dia].join(".");
    const startTime = hora.split(":").join(".");

    let urlBase = `${servidor}:${porta}/Interface/Cameras/Playback/GetJPEGStream?`;
    urlBase = `${urlBase}Camera=${codigo}&`;
    urlBase = `${urlBase}Width=${width}&`;
    urlBase = `${urlBase}Height=${height}&`;
    urlBase = `${urlBase}StartDate=${startDate}&`;
    urlBase = `${urlBase}StartTime=${startTime}`;

    return urlBase;
  }

  public getFeatureFlagDguardNovaApi(): Observable<any> {
    return this.get('api/v1/config-cameras/feature-flags/dguard-nova-api');
  }

}
